export enum UserGroupsEnum {
   
    /* Склад */
	warehouse = 8,

    /* Монтаж */
    install = 11,

    /* Администрация лаборатории  */
    laboratoryAdmins = 334,

    /* Научные сотрудники лаборатории  */
    laboratoryEmployees = 335,

    /* Руководители лаборатории  */
    laboratoryManagers = 338,
}